import type { permissions } from '@/common';

export type Permissible = {
    can?: string | boolean;
    permission?: permissions.PermissionLabel;
    anyPermissions?: permissions.PermissionLabel[];
    allPermissions?: permissions.PermissionLabel[];
};

export const usePermissionCheck = (checks: MaybeRefOrGetter<Permissible>) => {
    const { permissions } = useCompany();
    const hasPermission = computed(() => {
        const setup = toValue(checks);
        if (setup.can === true) {
            return true;
        }
        if (setup.permission) {
            return permissions.value[setup.permission];
        }
        if (setup.anyPermissions) {
            return setup.anyPermissions.some(p => permissions.value[p]);
        }
        if (setup.allPermissions) {
            return setup.allPermissions.every(p => permissions.value[p]);
        }
        return false;
    });

    const failureMessage = computed(() => {
        if (!hasPermission.value) {
            const setup = toValue(checks);
            if (typeof setup.can === 'string') {
                return setup.can;
            }
            return 'You do not have permission for this.';
        }
        return undefined;
    });

    return {
        hasPermission,
        failureMessage,
    };
};
